import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
import { loaiPT } from "../PatientInfo/config";
const { INPUT, DATE, COMBO_BOX, SELECT,AUTO_COMPLETE,SELECT_MULTI } = FIELD_TYPE;

const fields: DataFormField[] = [
  {
    name: "lyDoTuChoi",
    type: COMBO_BOX,
    css: {xl: 24, sm: 24},
    label: "Lý do từ chối",
  },
  {
    name: "thoiGianHenGoiLai",
    type: DATE,
    optionsTime: {format: FORMAT_TIME.dateTime, showTime: true},
    css: {xl: 24, sm: 24},
    label: "Thời gian hẹn gặp lại",
    disableDate: false,
  },
  {
    name: "ghiChu",
    type: INPUT,
    css: {xl: 24, sm: 24},
    label: "Ghi chú",
  },
  {
    name: "ghiChu",
    type: INPUT,
    css: {xl: 24, sm: 24},
    label: "Ghi chú",
  },
  {
    name: "loaiPhauThuat",
    type: COMBO_BOX,
    label: "Loại phẫu thuật",
    css: {xl: 24, sm: 24},
    options: loaiPT,
    rules: [{required: true, message: "Bắt buộc phải chọn loại phẫu thuật"}],
  },
];

const fieldsAgree = (type?) => {
  const fieldsAgree: DataFormField[] = [
    {
      name: "thoiGianHen",
      type: type,
      optionsTime: {format: FORMAT_TIME.dateTime, showTime: true},
      label: "Thời gian hẹn",
      css: {xl: 24, sm: 24},
      needConfirm: true,
      disableDate: false,
    },
    {
      name: "ghiChu",
      type: INPUT,
      label: "Ghi chú",
      css: {xl: 24, sm: 24},
    },

    {
      name: "lyDoNhapVien",
      type: INPUT,
      label: "Lý do nhập viện",
      css: {xl: 24, sm: 24},
    },
    {
      name: "loaiPhauThuat",
      type: COMBO_BOX,
      label: "Loại phẫu thuật",
      css: {xl: 24, sm: 24},
      options: loaiPT,
      rules: [{required: true, message: "Bắt buộc phải chọn loại phẫu thuật"}],
    },
  ];
  return fieldsAgree;
};

export {fields};

export default fieldsAgree;
